import React, { useState } from 'react';
import DialogComponent from '../../dialog/dialog.component';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useReactPost } from '../../../hooks/use-react-post/useReactPost';
import { useNavigate } from 'react-router-dom';

interface IPostListAction {
  visibleUpload: boolean;
  onClose: () => void;
  id: string;
  isMe: boolean;
}
export const PostListAction = ({
  visibleUpload,
  onClose,
  id,
  isMe,
}: IPostListAction) => {
  const [tab, setTab] = useState<1 | 0>(1);
  const { interactedUsers, hasMore, listAction } = useReactPost({
    postId: id,
    type: tab,
  });
  const handleTabChange = (newTab: 1 | 0) => {
    setTab(newTab);
  };

  const navigator = useNavigate();
  return (
    <DialogComponent
      visible={visibleUpload}
      onClose={onClose}
      placement="CENTER"
      title="Danh sách người tương tác"
      size="full"
      customSize="w-full max-w-[400px]"
    >
      <div className="p-6">
        <div className="flex  mb-4 border-b">
          <button
            onClick={() => handleTabChange(1)}
            className={`px-4 w-full py-2 text-gray-600 border-b-2 transition-all duration-200 ${
              tab === 1
                ? 'border-blue-500 text-blue-600 font-semibold'
                : 'border-transparent hover:text-blue-500'
            }`}
          >
            Likes
          </button>
          <button
            onClick={() => handleTabChange(0)}
            className={`px-4 w-full py-2 text-gray-600 border-b-2 transition-all duration-200 ${
              tab === 0
                ? 'border-blue-500 text-blue-600 font-semibold'
                : 'border-transparent hover:text-blue-500'
            }`}
          >
            Dislikes
          </button>
        </div>

        {interactedUsers.length > 0 ? (
          <InfiniteScroll
            dataLength={interactedUsers.length}
            next={() => listAction()}
            hasMore={hasMore}
            loader={<p>Đang tải...</p>}
            scrollableTarget="body"
          >
            {interactedUsers.map((user) => (
              <div key={user.userId} className="p-2 border-b">
                <div className="flex items-center gap-3 justify-between">
                  <div
                    onClick={() => {
                      navigator(isMe ? '/profile' : `/user/${user.username}`);
                    }}
                    className="flex cursor-pointer items-center gap-3"
                  >
                    <img
                      src={
                        user.avatar ||
                        '/default-avatar.svg'
                      }
                      alt={user.fullName}
                      className="w-10 h-10 rounded-full"
                    />
                    <div>
                      <p className="font-semibold">{user.fullName}</p>
                      <p className="text-sm text-gray-500">@{user.username}</p>
                    </div>
                  </div>
                  <div>
                    {user.interactionType === 'UpVote' ? (
                      <span className="text-blue-500 text-lg">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.59375 12.3265V5.55315C5.59375 5.28649 5.67375 5.02649 5.82042 4.80649L7.64042 2.09982C7.92708 1.66649 8.64042 1.35982 9.24708 1.58649C9.90042 1.80649 10.3337 2.53982 10.1937 3.19315L9.84708 5.37315C9.82042 5.57315 9.87375 5.75315 9.98708 5.89315C10.1004 6.01982 10.2671 6.09982 10.4471 6.09982H13.1871C13.7137 6.09982 14.1671 6.31315 14.4337 6.68649C14.6871 7.04649 14.7337 7.51315 14.5671 7.98649L12.9271 12.9798C12.7204 13.8065 11.8204 14.4798 10.9271 14.4798H8.32708C7.88042 14.4798 7.25375 14.3265 6.96708 14.0398L6.11375 13.3798C5.78708 13.1332 5.59375 12.7398 5.59375 12.3265Z"
                            fill="currentColor"
                          />
                          <path
                            d="M3.47398 4.25293H2.78732C1.75398 4.25293 1.33398 4.65293 1.33398 5.6396V12.3463C1.33398 13.3329 1.75398 13.7329 2.78732 13.7329H3.47398C4.50732 13.7329 4.92732 13.3329 4.92732 12.3463V5.6396C4.92732 4.65293 4.50732 4.25293 3.47398 4.25293Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                    ) : user.interactionType === 'DownVote' ? (
                      <span className="text-red-500">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.4073 3.66701V10.4403C10.4073 10.707 10.3273 10.967 10.1807 11.187L8.36066 13.8937C8.07399 14.327 7.36066 14.6337 6.75399 14.407C6.10066 14.187 5.66733 13.4537 5.80733 12.8003L6.15399 10.6203C6.18066 10.4203 6.12733 10.2403 6.014 10.1003C5.90066 9.97367 5.73399 9.89367 5.554 9.89367H2.81399C2.28733 9.89367 1.83399 9.68034 1.56733 9.307C1.31399 8.94701 1.26733 8.48034 1.43399 8.007L3.07399 3.01367C3.28066 2.18701 4.18066 1.51367 5.074 1.51367H7.674C8.12066 1.51367 8.74733 1.66701 9.03399 1.95367L9.88733 2.61367C10.214 2.86701 10.4073 3.25367 10.4073 3.66701Z"
                            fill="currentColor"
                          />
                          <path
                            d="M12.5276 11.7399H13.2142C14.2476 11.7399 14.6676 11.3399 14.6676 10.3533V3.65327C14.6676 2.6666 14.2476 2.2666 13.2142 2.2666H12.5276C11.4942 2.2666 11.0742 2.6666 11.0742 3.65327V10.3599C11.0742 11.3399 11.4942 11.7399 12.5276 11.7399Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        ) : (
          <p className="text-center text-gray-500">Chưa có tương tác.</p>
        )}
      </div>
    </DialogComponent>
  );
};
